<template>
  <model-form
    :model="ticket"
    modal-type="modal"
  >
    <q-card-section>
      <div class="row q-gutter-md">
        <q-input
          :model-value="ticket.id"
          readonly
          class="col"
          label="ID"
          bottom-slots
          autofocus
        />
        <q-input
          :model-value="ticket.ticketNumber"
          readonly
          class="col"
          label="Ticket Number"
          bottom-slots
          autofocus
        />
      </div>
      <div class="row q-gutter-md">
        <q-input
          :model-value="ticket.user && ticket.user.name"
          readonly
          class="col"
          label="User Name"
          bottom-slots
          autofocus
        />
        <q-input
          v-model.number="ticket.price"
          readonly
          class="col"
          label="Price"
          :prefix="currentCircuit.localeCurrencySymbol"
          type="number"
          bottom-slots
        />
        <q-select
          v-model="ticket.seatName"
          class="col q-pr-md"
          label="Seat"
          :options="availableSeats || []"
          bottom-slots
        />
      </div>
    </q-card-section>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'TicketForm',
  components: {
    ModelForm
  },
  props: {
    availableSeats: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  configuration: ['currentCircuit'],
  models: {
    ticket: 'default'
  }
}

</script>
